<div class="legal-mention-container" [innerHTML]="sanitizedContent"></div>
